import Api from './BaseRequest';

export function GetAlertText() {
    return Api.Get('/api/alert-text');
}